import { atom } from 'jotai/vanilla';
export function atomWithStore(store) {
    const baseAtom = atom(store.getState());
    if (process.env.NODE_ENV !== 'production') {
        baseAtom.debugPrivate = true;
    }
    baseAtom.onMount = (setValue) => {
        const callback = () => {
            setValue(store.getState());
        };
        const unsub = store.subscribe(callback);
        callback();
        return unsub;
    };
    const derivedAtom = atom((get) => get(baseAtom), (get, _set, update) => {
        const newState = typeof update === 'function'
            ? update(get(baseAtom))
            : update;
        store.setState(newState, true /* replace */);
    });
    return derivedAtom;
}
